import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.158 4a.667.667 0 0 0-.667.667V6a.667.667 0 1 0 1.333 0V4.667A.667.667 0 0 0 8.158 4m0-2.667A4.667 4.667 0 0 0 3.49 6v4a4.667 4.667 0 1 0 9.333 0V6a4.667 4.667 0 0 0-4.666-4.667M11.49 10a3.334 3.334 0 0 1-6.667 0V6a3.333 3.333 0 0 1 6.667 0z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })